import React, { useState } from "react";
import Footer from "./Footer";
import passportGood from "../../../assets/images/passportguideline.png";
import { ChevronRight } from "lucide-react";
import useStickyButton from "../hooks/useStickyButton";
import isMobileDevice from "../../../utils/isMobileDevice";
import DesktopQrModal from "../../../components/DesktopQrModal";
import SecureCamera from "../../../components/SecureCamera/SecureCamera";

const GuidelinePassport = (props) => {
  const { onNext } = props;

  const [showCamera, setShowCamera] = useState(false);
  const [showDesktopNotice, setShowDesktopNotice] = useState(false);
  const { buttonContainerRef, sentinelRef, isSticky, buttonHeight } = useStickyButton();

  const handleOpenCamera = () => {
    if (!isMobileDevice()) {
      setShowDesktopNotice(true);
      return;
    }
    setShowDesktopNotice(false);
    setShowCamera(true);
  };

  const handleSecureCapture = ({ file }) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      onNext(reader.result);
    };
  };

  return (
    <div className="p-4 rounded-t-xl bg-white flex flex-col h-full min-h-screen">
      <SecureCamera
        isOpen={showCamera}
        onClose={() => setShowCamera(false)}
        onCapture={handleSecureCapture}
        frameType="PASSPORT"
        title="Place your open passport within the frame"
        theme={{ primaryColor: "#2563eb", textColor: "#ffffff" }}
      />
      <h2 className="text-xl font-bold mb-2">
        Take a photo
        <br />
        of your <span className="text-blue-600">Passport</span>
      </h2>
      <p className="text-gray-500 mb-6 md:mb-8 text-left max-w-prose">
        Please make sure the MRZ is clear, readable and at the <strong>bottom</strong> of the image. We show a sample
        photo below to help you get it right.
      </p>

      <div className="flex flex-col items-center mb-8">
        <div className="mb-2 flex items-center justify-center">
          <img src={passportGood} className="w-80 h-auto rounded-lg shadow-md shadow-black" />
        </div>
      </div>

      <div className="flex flex-1" />

      {/* Sentinel element for Intersection Observer */}
      <div ref={sentinelRef} style={{ height: "1px", visibility: "hidden" }} />

      {/* Spacer to maintain space when button is sticky */}
      {isSticky && buttonHeight > 0 && (
        <div style={{ height: `${buttonHeight}px`, width: "100%" }} />
      )}

      <div 
        ref={buttonContainerRef}
        style={{
          position: isSticky ? "fixed" : "relative",
          bottom: isSticky ? "0" : "auto",
          left: isSticky ? "0" : "auto",
          right: isSticky ? "0" : "auto",
          padding: isSticky ? "1rem" : "0",
          background: "transparent",
          zIndex: isSticky ? "50" : "auto",
          transition: "all 0.3s ease-in-out",
          pointerEvents: isSticky ? "none" : "auto",
        }}
      >
        <button
          className="w-2/3 bg-blue-600 text-white py-3 px-4 rounded-full flex items-center justify-center space-x-2 mx-auto transition active:scale-95 duration-150 ease-in-out"
          style={{ pointerEvents: "auto" }}
          onClick={handleOpenCamera}
          onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
          onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          onTouchStart={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
          onTouchEnd={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <span>Continue</span>
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>

      <DesktopQrModal open={showDesktopNotice} onClose={() => setShowDesktopNotice(false)} />

      <Footer />
    </div>
  );
};

export default GuidelinePassport;
